import React = require("react");
import {SecondaryTitle} from "../../../components/Title";
import {PrettyPrinter} from "../../../components/Utils/PrettyPrinter";
import {Legend} from "../../../components/charts/Legend";
import {PieChart, PieChartRow} from "../../../components/charts/PieChart";
import {PercentageCircle} from "../../../components/charts/PercentageCircle";
import "./MarketingSalesWithBestWidget.scss";
import {VeBoxCard} from "../../../components/card/VeBoxCard";
import {Display} from "../../../components/Display";
import {EmptyState, infoIcons} from "@vebox/etui-core";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";

interface BestSaleEntityData {
    title: string;
    name: string;
    color: string;
    percentageOfTotal: number;
    quantity: number;
    unitOfMeasure: string;
}

interface MarketingSalesWithBestWidgetProps {
    title: string;
    bestSaleEntityData: BestSaleEntityData;
    chartDataSet: PieChartRow[];
    wide: boolean;
}

interface MarketingSalesWithBestWidgetState {
    selectedItemName: string;
}

declare var AppTranslations: AppTranslations;

export class MarketingSalesWithBestWidget
    extends React.Component<MarketingSalesWithBestWidgetProps, MarketingSalesWithBestWidgetState> {

    constructor(props: MarketingSalesWithBestWidgetProps) {
        super(props);
        this.state = {selectedItemName: null};
        this.setSelectedItem = this.setSelectedItem.bind(this);
    }

    public setSelectedItem(itemName: string): void {
        this.setState({selectedItemName: itemName});
    }

    public render() {
        let dataSet = this.props.chartDataSet;

        const total = dataSet.map((item) => {
            return item.frequency;
        }).reduce((a, b) => {
            return a + b;
        }, 0);
        const getPercentage = (t: number, value: number): number => {
            return 100 * value / t;
        };
        const compareTo = (a: number, b: number) => {
            if (a === b) {
                return 0;
            }
            if (a > b) {
                return 1;
            }
            return -1;
        };
        dataSet = dataSet.sort((a, b) => compareTo(b.frequency, a.frequency));
        const legendItems = dataSet.map((item) => {
                const percentage = getPercentage(total, item.frequency);
                // let value = percentage.toFixed(1) + "%";
                // if (percentage < 0.1 && percentage > 0) {
                //     value = "< 0.1%";
                // }
                return {
                    color: item.color,
                    name: item.label,
                    value: item.frequency,
                    percentage,
                };
            },
        );
        let widgetClassName = "marketing-widget";
        if (this.props.wide) {
            widgetClassName += " marketing-widget-2x3";
        } else {
            widgetClassName += " marketing-widget-2x2 marketing-widget-2x2--reduced";
        }

        return (
            <VeBoxCard className={widgetClassName + " no-margin"}>
                <VeBoxCard.Header title={this.props.title}/>
                <Display isVisible={this.props.bestSaleEntityData != null}>
                    <VeBoxCard.Body className="marketing-widget__content marketing-sales-with-best-widget">
                        <Display isVisible={this.props.chartDataSet.length === 0}>
                            <EmptyState>
                                <EmptyState.InfoIcon
                                    styles={{
                                        root: {
                                            color: "var(--empty-indicator-svg-stroke)",
                                        }
                                    }}
                                    glyph={infoIcons.NoContent}
                                />
                                <EmptyState.Title color="var(--empty-indicator-title-color)">{AppTranslations.noDataAvailable}</EmptyState.Title>
                                <EmptyState.SubTitle color="var(--empty-indicator-subtitle-color)">{AppTranslations.miscellaneous.checkFiltersMessage}</EmptyState.SubTitle>
                            </EmptyState>
                        </Display>
                        <Display isVisible={this.props.chartDataSet.length > 0}>
                            <div className="sales-chart__container">
                                <div className="sales-chart__graph">
                                    <PieChart
                                        radius={145}
                                        data={dataSet}
                                        selectedItem={this.state.selectedItemName}
                                        onPathHover={this.setSelectedItem}
                                    />
                                </div>
                                <div className="sales-chart-legend__container">
                                    <Legend
                                        items={legendItems}
                                        selectedItemName={this.state.selectedItemName}
                                        onItemHover={this.setSelectedItem}
                                    />
                                </div>
                            </div>
                            <SecondaryTitle title={this.props.bestSaleEntityData.title}/>
                            <div className="best-entity">
                                <div className="best-entity__info">
                                    <p>
                                        <span className="best-entity__name">{this.props.bestSaleEntityData.name}</span>
                                        <span className="best-entity__quantity">
                                {PrettyPrinter.salesQuantity(this.props.bestSaleEntityData.quantity)}
                            </span>
                                        <span className="best-entity__unit-of-measure">
                                    {this.props.bestSaleEntityData.unitOfMeasure}
                                </span>
                                    </p>
                                </div>
                                <div className="best-entity__chart">
                                    <PercentageCircle
                                        width={75}
                                        height={75}
                                        percentage={this.props.bestSaleEntityData.percentageOfTotal * 100}
                                        name={this.props.bestSaleEntityData.name}
                                        percentageColor={this.props.bestSaleEntityData.color}
                                        arcWidth={9}
                                    />
                                </div>
                            </div>
                        </Display>
                    </VeBoxCard.Body>
                </Display>
            </VeBoxCard>
        );
    }
}
